//navigation styles
const nav_color = "#6e6e73";
const nav_bg_color = "white";
const nav_border_color = "black";
const nav_hover_bg_color = "#cccccc";
const nav_hover_color = "white";
//Choice styles
const choice_bg_color = "white";
const choice_color = "black";
const choice_border_color = "black";
const choice_hover_color = "white";
const choice_hover_bg_color = "#6e6e73";
//Correct
const correct_bg_color = "green";
const correct_color = "white";
const correct_border_color = "black";
//Correct disabled
const correctdisabled_bg_color = "green";
const correctdisabled_color = "white";
const correctdisabled_border_color = "blue";

//incorrect disabled
const incorrectdisabled_bg_color = "red";
const incorrectdisabled_color = "white";
const incorrectdisabled_border_color = "green";

//incorrect
const incorrect_bg_color = "red";
const incorrect_color = "white";
const incorrect_border_color = "green";

//selected
const selected_bg_color = "#6e6e73";
const selected_color = "white";
const selected_border_color = "black";
const selected_hover_bg_color = "#6e6e73";
const selected_hover_color = "white";

//progress
const progress_bg_color = "#63b4ed";

//Box
const box_color = "blue";

//Custom h1
const custom_h1_basestyle_color = "inherit";
const custom_h1_basestyle_font_family = "inherit";
const custom_h1_basestyle_font_size = "2em";

//Custom h2
const custom_h2_basestyle_color = "inherit";
const custom_h2_basestyle_font_family = "inherit";
const custom_h2_basestyle_font_size = "1.5em";

//Custom h3
const custom_h3_basestyle_color = "inherit";
const custom_h3_basestyle_font_family = "inherit";
const custom_h3_basestyle_font_size = "1.17em";

//Custom h4
const custom_h4_basestyle_color = "inherit";
const custom_h4_basestyle_font_family = "inherit";
const custom_h4_basestyle_font_size = "1em";

//Custom p
const custom_p_basestyle_color = "inherit";
const custom_p_basestyle_font_family = "inherit";
const custom_p_basestyle_font_size = "16px";

//Custom Link
const custom_link_basestyle_color = "blue";
const custom_link_basestyle_font_family = "inherit";
const custom_link_basestyle_font_size = "16px";

//Button
const button_basestyle_font_weight = "bold";
const button_basestyle_color = "inherit";
const button_basestyle_font_size = "16px";
const button_basestyle_bg_color = "63b4ed";
const button_basestyle_hover_color = "black";
const button_basestyle_hover_bg_color = "inherit";
const button_variants_solid_bg = "#63b4ed";
const button_variants_solid_color = "white";
const button_variants_solid_hover_color = "black";
const button_variants_solid_hover_bg = "inherit";

//stat
const stat_color = "black";
const stat_bg_color = "white";
const stat_hover_bg_color = "#6e6e73";
const stat_hover_color = "white";
const stat_border_color = "black";

export default {
  colors: {
    progressbar: {
      500: progress_bg_color,
    },
    nav: {
      500: nav_hover_color,
    },
  },
  textStyles: {
    nav: {
      color: nav_color,
    },
  },
  layerStyles: {
    sidemenu: {
      borderRadius: "0.35rem",
    },
    nav: {
      fontWeight: "bold",
      borderRadius: "base",
      color: nav_color,
      bg: nav_bg_color,
      border: `2px solid ${nav_border_color}`,
      _hover: {
        bg: nav_hover_bg_color,
        cursor: "pointer",
      },
    },

    choice: {
      bg: choice_bg_color,
      color: choice_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${choice_border_color}`,
      margin: 2,
      _hover: {
        color: choice_hover_color,
        bg: choice_hover_bg_color,
      },
    },
    correct: {
      bg: correct_bg_color,
      color: correct_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${correct_border_color}`,
      margin: 2,
    },
    correctdisabled: {
      bg: correctdisabled_bg_color,
      color: correctdisabled_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${correctdisabled_border_color}`,
      margin: 2,
      _hover: {
        color: correctdisabled_color,
        bg: correctdisabled_bg_color,
      },
    },
    incorrectdisabled: {
      bg: incorrectdisabled_bg_color,
      color: incorrectdisabled_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${incorrectdisabled_border_color}`,
      margin: 2,
      _hover: {
        color: incorrectdisabled_color,
        bg: incorrectdisabled_bg_color,
      },
    },
    incorrect: {
      bg: incorrect_bg_color,
      color: incorrect_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${incorrect_border_color}`,
      margin: 2,
      _hover: {
        color: incorrect_color,
        bg: incorrect_bg_color,
      },
    },
    selected: {
      bg: selected_bg_color,
      color: selected_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${selected_border_color}`,
      margin: 2,
      _hover: {
        color: selected_hover_color,
        bg: selected_hover_bg_color,
      },
    },
    stat: {
      bg: stat_bg_color,
      color: stat_color,
      padding: "1rem",
      marginTop: 4,
      py: 3,
      border: `1px solid ${stat_border_color}`,
      margin: 2,
      _hover: {
        color: stat_hover_color,
        bg: stat_hover_bg_color,
        cursor: "pointer",
      },
    },
  },
  components: {
    CustomProgress: {
      baseStyle: {
        colorScheme: "red",
      },
    },
    Box: {
      color: box_color,
    },

    CustomH1: {
      baseStyle: {
        color: custom_h1_basestyle_color,
        fontFamily: custom_h1_basestyle_font_family,
        fontSize: custom_h1_basestyle_font_size,
      },
    },

    CustomH2: {
      baseStyle: {
        color: custom_h2_basestyle_color,
        fontFamily: custom_h2_basestyle_font_family,
        fontSize: custom_h2_basestyle_font_size,
      },
    },

    CustomH3: {
      baseStyle: {
        color: custom_h3_basestyle_color,
        fontFamily: custom_h3_basestyle_font_family,
        fontSize: custom_h3_basestyle_font_size,
      },
    },

    CustomH4: {
      baseStyle: {
        color: custom_h4_basestyle_color,
        fontFamily: custom_h4_basestyle_font_family,
        fontSize: custom_h4_basestyle_font_size,
      },
    },

    CustomP: {
      baseStyle: {
        color: custom_p_basestyle_color,
        fontFamily: custom_p_basestyle_font_family,
        fontSize: custom_p_basestyle_font_size,
      },
    },

    CustomLink: {
      baseStyle: {
        color: custom_link_basestyle_color,
        fontFamily: custom_link_basestyle_font_family,
        fontSize: custom_link_basestyle_font_size,
      },
    },

    Button: {
      baseStyle: {
        fontWeight: button_basestyle_font_weight,
        fontSize: button_basestyle_font_size,
        borderRadius: "base",
        color: button_basestyle_color,
        bg: button_basestyle_bg_color,
        _hover: {
          color: button_basestyle_hover_color,
          bg: button_basestyle_hover_bg_color,
        },
      },

      variants: {
        solid: {
          bg: button_variants_solid_bg,
          color: button_variants_solid_color,
          _hover: {
            color: button_variants_solid_hover_color,
            bg: button_variants_solid_hover_bg,
          },
        },
      },
    },
  },
};
